(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["NS-how-to-choose-chrome"] && !Shopify.designMode) return;
  try {
    
(() => {
  // Reuse existing catalogue cards. Filtered-out families fall back to a family filter URL.
  const familyTarget = link => {
    const path = new URL(link.dataset.nsChromeProduct, location.origin).pathname;
    const cardLink = Array.from(document.querySelectorAll('#product-grid a[href]')).find(a => new URL(a.href, location.origin).pathname === path);
    const card = cardLink?.closest('li');
    if (card) { card.id = 'chrome-family-' + link.dataset.nsChromeFamily; card.classList.add('ns-chrome-family-anchor'); }
    return card;
  };
  const familyLinks = () => document.querySelectorAll('.ns-chrome-guide a[data-ns-chrome-family][href*="#chrome-family-"]');
  const initFamilies = () => {
    for (const link of familyLinks()) familyTarget(link);
    if (location.hash.startsWith('#chrome-family-')) document.getElementById(location.hash.slice(1))?.scrollIntoView();
  };
  document.addEventListener('click', event => {
    const link = event.target.closest('.ns-chrome-guide a[data-ns-chrome-family][href*="#chrome-family-"]');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const target = familyTarget(link);
    if (!target) return;
    event.preventDefault();
    history.replaceState(null, '', '#' + target.id);
    target.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start'});
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initFamilies, {once:true});
  else initFamilies();

  const init = () => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
    const badges = document.querySelectorAll('[data-ns-chrome-bestseller]:not([data-ns-observed])');
    if (!badges.length) return;
    const observer = new IntersectionObserver(entries => {
      for (const entry of entries) if (entry.isIntersecting) {
        entry.target.classList.add('ns-chrome-guide__badge--seen');
        observer.unobserve(entry.target);
      }
    }, { threshold: 0.5 });
    for (const badge of badges) { badge.dataset.nsObserved = 'true'; observer.observe(badge); }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["NS-siranush-biography"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ns-bio-creative-gallery')) {
    customElements.define('ns-bio-creative-gallery', class extends HTMLElement {
      connectedCallback() {
        this.cleanup = new AbortController();
        const options = { signal: this.cleanup.signal };
        const track = this.querySelector('[data-creative-track]');
        const slides = Array.from(this.querySelectorAll('.ns-bio__creative-slide'));
        const dotsWrap = this.querySelector('[data-creative-dots]');
        const previous = this.querySelector('[data-creative-prev]');
        const next = this.querySelector('[data-creative-next]');
        const openButtons = Array.from(this.querySelectorAll('[data-creative-open]'));
        const dialog = this.querySelector('[data-creative-dialog]');
        const dialogImage = this.querySelector('[data-lightbox-image]');
        const dialogClose = this.querySelector('[data-lightbox-close]');
        const dialogPrevious = this.querySelector('[data-lightbox-prev]');
        const dialogNext = this.querySelector('[data-lightbox-next]');
        if (!track || !slides.length) return;

        const activeIndex = () => {
          const left = track.getBoundingClientRect().left;
          return slides.reduce((best, slide, index) =>
            Math.abs(slide.getBoundingClientRect().left - left) < Math.abs(slides[best].getBoundingClientRect().left - left) ? index : best, 0);
        };
        const goTo = index => {
          const slide = slides[Math.max(0, Math.min(slides.length - 1, index))];
          const left = track.scrollLeft + slide.getBoundingClientRect().left - track.getBoundingClientRect().left;
          track.scrollTo({ left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        };
        const dots = dotsWrap ? slides.map((slide, index) => {
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.className = `ns-slider-dot${index === 0 ? ' is-active' : ''}`;
            dot.setAttribute('aria-label', this.dataset.portraitLabel.replace('__INDEX__', String(index + 1)));
            dot.addEventListener('click', () => goTo(index), options);
            dotsWrap.appendChild(dot);
            return dot;
          }) : [];
        const update = () => {
          const current = activeIndex();
          dots.forEach((dot, index) => dot.classList.toggle('is-active', index === current));
        };
        previous?.addEventListener('click', () => goTo(activeIndex() - 1), options);
        next?.addEventListener('click', () => goTo(activeIndex() + 1), options);

        let lightboxIndex = 0;
        const showLightboxImage = index => {
          lightboxIndex = (index + openButtons.length) % openButtons.length;
          const source = openButtons[lightboxIndex];
          dialogImage.src = source.dataset.fullSrc;
          dialogImage.alt = source.querySelector('img')?.alt || this.dataset.portraitFallback;
        };
        const openLightbox = index => {
          if (!dialog || !dialogImage || typeof dialog.showModal !== 'function') return;
          showLightboxImage(index);
          dialog.showModal();
        };
        openButtons.forEach((button, index) => button.addEventListener('click', () => openLightbox(index), options));
        dialogClose?.addEventListener('click', () => dialog.close(), options);
        dialogPrevious?.addEventListener('click', () => showLightboxImage(lightboxIndex - 1), options);
        dialogNext?.addEventListener('click', () => showLightboxImage(lightboxIndex + 1), options);
        dialog?.addEventListener('click', event => {
          if (event.target === dialog) dialog.close();
        }, options);
        dialog?.addEventListener('keydown', event => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          showLightboxImage(lightboxIndex + (event.key === 'ArrowRight' ? 1 : -1));
        }, options);

        track.addEventListener('scroll', update, { ...options, passive: true });
        track.addEventListener('keydown', event => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          goTo(activeIndex() + (event.key === 'ArrowRight' ? 1 : -1));
        }, options);
        this.resizeObserver = new ResizeObserver(update);
        this.resizeObserver.observe(track);
        update();
      }

      disconnectedCallback() {
        this.cleanup?.abort();
        this.resizeObserver?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["NS-student-work-results"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ns-student-results')) {
    customElements.define('ns-student-results', class extends HTMLElement {
      connectedCallback() {
        this.cleanup = new AbortController();
        const options = { signal: this.cleanup.signal };
        const track = this.querySelector('.ns-student-results__track');
        const slides = Array.from(this.querySelectorAll('.ns-student-results__slide'));
        const dotsWrap = this.querySelector('[data-dots]');
        if (!track || !slides.length || !dotsWrap) return;
        const index = () => {
          const left = track.getBoundingClientRect().left;
          return slides.reduce((best, slide, i) => Math.abs(slide.getBoundingClientRect().left - left) < Math.abs(slides[best].getBoundingClientRect().left - left) ? i : best, 0);
        };
        const update = () => {
          const active = index();
          dots.forEach((dot, i) => dot.classList.toggle('is-active', i === active));
        };
        const go = (i) => {
          const slide = slides[Math.max(0, Math.min(slides.length - 1, i))];
          const left = track.scrollLeft + slide.getBoundingClientRect().left - track.getBoundingClientRect().left;
          track.scrollTo({ left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        };
        const dots = slides.map((slide, i) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = `ns-slider-dot${i === 0 ? ' is-active' : ''}`;
          dot.setAttribute('aria-label', `Go to student result ${i + 1}`);
          dot.addEventListener('click', () => go(i), options);
          dotsWrap.appendChild(dot);
          return dot;
        });
        track.addEventListener('scroll', update, { ...options, passive: true });
        track.addEventListener('keydown', event => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          go(index() + (event.key === 'ArrowRight' ? 1 : -1));
        }, options);
        this.addEventListener('shopify:block:select', event => {
          const selected = slides.findIndex(slide => slide === event.target || slide.contains(event.target));
          if (selected >= 0) go(selected);
        }, options);
        this.resizeObserver = new ResizeObserver(update);
        this.resizeObserver.observe(track);
        update();
      }
      disconnectedCallback() {
        this.cleanup?.abort();
        this.resizeObserver?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      if (!this.header) return; // на всякий

      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      // The portal controller owns header geometry, including font/image resizing.
      // Keep the original measurement fallback for any non-portal header.
      if (!this.classList.contains('ns-portal-header')) {
        this.setHeaderHeight();
        this.headerSizeMedia = window.matchMedia('(max-width: 1099px)');
        this.onHeaderSizeChange = this.setHeaderHeight.bind(this);
        this.headerSizeMedia.addEventListener?.('change', this.onHeaderSizeChange);
      }

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      if (!this.header) return;
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      this.headerSizeMedia?.removeEventListener?.('change', this.onHeaderSizeChange);
    }

    createObserver() {
      if (!this.header) return;
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = (entries[0] && entries[0].intersectionRect) || {};
        observer.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      if (!this.headerBounds) return;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.preventHide || [...this.querySelectorAll('predictive-search')].some(search => search.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > (this.headerBounds.bottom || 0)) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > (this.headerBounds.bottom || 0)) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= (this.headerBounds.top || 0)) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      // закрываем поиск только если стандартный modal существует
      if (this.header.querySelector('details-modal')) this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      if (this.disclosures && this.disclosures.forEach) {
        this.disclosures.forEach(
          (disclosure) => disclosure && typeof disclosure.close === 'function' && disclosure.close()
        );
      }
    }

    closeSearchModal() {
      // В твоей теме стандартный details-modal заменён (ezfy), поэтому модалки может не быть.
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal && typeof this.searchModal.close === 'function') {
        this.searchModal.close(false);
      }
    }
  }

  if (!customElements.get('sticky-header')) customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ns-floating-navigation"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ns-floating-navigation')) {
    customElements.define('ns-floating-navigation', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.actions = this.querySelectorAll('[data-nav-action]');
        this.topLink = this.querySelector('[data-nav-top]');
        const offset = (value, fallback) => {
          const parsed = Number(value);
          return Number.isFinite(parsed) && parsed >= 0 ? parsed : fallback;
        };
        this.actionOffset = offset(this.dataset.actionOffset, 160);
        this.topOffset = offset(this.dataset.topOffset, 720);
        this.frame = 0;
        this.update = () => {
          this.frame = 0;
          const y = window.scrollY || 0;
          const preview = !!window.Shopify?.designMode;
          this.actions.forEach(link => { link.hidden = !preview && y < this.actionOffset; });
          if (this.topLink) this.topLink.hidden = !preview && y < this.topOffset;
        };
        this.schedule = () => {
          if (!this.frame) this.frame = requestAnimationFrame(this.update);
        };
        window.addEventListener('scroll', this.schedule, { ...options, passive: true });
        window.addEventListener('pageshow', this.update, options);
        this.topLink?.addEventListener('click', event => {
          event.preventDefault();
          window.scrollTo({ top: 0, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        }, options);
        this.update();
      }
      disconnectedCallback() {
        this.controller?.abort();
        cancelAnimationFrame(this.frame);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
